import React from "react";
import ReleaseHistory from "./ReleaseHistory";
import NewsUpdates from "./NewsUpdates";
import ShowcaseFB from "./ShowcaseFB";
import FooterMain from "../MainPage/FooterMain";
import HeaderNavMain from "../MainPage/HeaderNavMain";
import HeroFB from "./HeroFB";

export default function FloatBlock() {
  return (
    <main className="relative w-full min-h-screen bg-gradient-to-b from-black via-[#0a0a0a] to-[#111] text-white overflow-hidden">
      <div className="relative w-full">
        <div className="absolute top-0 left-0 w-full z-50">
          <HeaderNavMain />
        </div>
        <div className="relative z-0">
          <HeroFB />
        </div>
      </div>

      <ShowcaseFB />
      <NewsUpdates />
      <ReleaseHistory />
      <FooterMain />
    </main>
  );
}
